import { Instagram, MessageCircle, ArrowUpRight } from "lucide-react";
import { useLang, waLink, scrollToId } from "@/lib/site";
import { copy } from "@/lib/content";
import { Reveal } from "./Reveal";
import { Wordmark } from "./Logo";

const TikTok = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48Z" />
  </svg>
);

const socials = [
  { id: "whatsapp", Icon: MessageCircle, label: "+62 821-2425-5020" },
  { id: "instagram", Icon: Instagram, href: "#", label: "Instagram" },
  { id: "tiktok", Icon: TikTok, href: "#", label: "TikTok" },
];

export const Footer = () => {
  const { lang } = useLang();
  const t = copy[lang];
  return (
    <footer id="kontak" data-testid="site-footer" className="relative overflow-hidden border-t border-amber-200/10 bg-[#05070D] pt-28">
      <div className="hero-aura pointer-events-none absolute inset-0 opacity-60" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <h2 className="font-display text-5xl sm:text-7xl lg:text-8xl leading-[0.98] text-slate-50">{t.footerTitle[0]}<br /><em className="text-gold">{t.footerTitle[1]}</em></h2>
          <div className="mt-10 flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
            <p className="max-w-md text-slate-300 text-base sm:text-lg">{t.footerSub}</p>
            <a data-testid="footer-whatsapp-cta" href={waLink(t.waHello)} target="_blank" rel="noopener noreferrer" className="btn-gold group inline-flex items-center justify-center gap-3 rounded-full px-8 py-4 font-semibold">
              {t.footerCta}<ArrowUpRight size={18} className="transition-transform duration-300 group-hover:rotate-45" />
            </a>
          </div>
        </Reveal>
        <div className="mt-24 flex flex-col gap-10 border-t border-white/5 py-10 lg:flex-row lg:items-center lg:justify-between">
          <button data-testid="footer-logo" onClick={() => scrollToId("beranda")} className="group text-left"><Wordmark /></button>
          <div className="flex flex-wrap gap-3">
            {socials.map(({ id, Icon, href, label }) => (
              <a key={id} data-testid={`social-${id}-link`} href={href || waLink(t.waHello)} target={href ? undefined : "_blank"} rel="noopener noreferrer" aria-label={label}
                className="social-chip inline-flex items-center gap-2 rounded-full border border-amber-200/15 px-4 py-2.5 text-sm text-slate-300">
                <Icon size={16} className="text-amber-300" />{label}
              </a>
            ))}
          </div>
        </div>
        <p data-testid="footer-copyright" className="pb-10 font-mono text-xs uppercase tracking-[0.2em] text-slate-400">© 2026 Rinda Marbun · {t.rights}</p>
      </div>
    </footer>
  );
};
